import React from 'react';
import useLanguage from '../../hooks/useLanguage';
import contactData from '../../data/contact.json';
import { FiPhone, FiMail, FiClock, FiMapPin } from 'react-icons/fi';
import Card from '../common/Card';

/**
 * ContactInfo Component
 * Displays company contact information with icons
 */
const ContactInfo = () => {
  const { language } = useLanguage();
  const { contactInfo } = contactData;

  const infoItems = [
    {
      icon: FiPhone,
      label: language === 'ko' ? '대표 전화' : 'Phone',
      value: contactInfo.phone,
      color: 'text-blue-600'
    },
    {
      icon: FiMail,
      label: language === 'ko' ? '일반 문의' : 'General Inquiry',
      value: contactInfo.email,
      color: 'text-blue-600'
    },
    {
      icon: FiMail,
      label: language === 'ko' ? '영업 문의' : 'Sales',
      value: contactInfo.salesEmail,
      color: 'text-blue-600'
    },
    {
      icon: FiMail,
      label: language === 'ko' ? '기술 지원' : 'Technical Support',
      value: contactInfo.supportEmail,
      color: 'text-blue-600'
    },
    {
      icon: FiClock,
      label: language === 'ko' ? '운영 시간' : 'Business Hours',
      value: language === 'ko' ? contactInfo.supportHours : contactInfo.supportHoursEn,
      color: 'text-green-600'
    },
    {
      icon: FiMapPin,
      label: language === 'ko' ? '주소' : 'Address',
      value: language === 'ko' ? contactInfo.address : contactInfo.addressEn,
      color: 'text-red-600'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Section Title */}
      <div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
          {language === 'ko' ? '연락처 정보' : 'Contact Information'}
        </h2>
        <p className="text-gray-600">
          {language === 'ko'
            ? '아래 연락처로 직접 문의하실 수 있습니다.'
            : 'You can contact us directly using the information below.'}
        </p>
      </div>

      {/* Contact Info Cards */}
      <div className="space-y-4">
        {infoItems.map((item, index) => (
          <Card key={index} className="p-4 hover:shadow-lg transition-shadow duration-300">
            <div className="flex items-start space-x-4">
              {/* Icon */}
              <div className={`flex-shrink-0 ${item.color}`}>
                <item.icon className="w-6 h-6" />
              </div>

              {/* Label and Value */}
              <div className="flex-1">
                <p className="text-sm font-semibold text-gray-700 mb-1">
                  {item.label}
                </p>
                <p className="text-gray-900 break-words">
                  {item.value}
                </p>
              </div>
            </div>
          </Card>
        ))}
      </div>

      {/* Additional Info */}
      <Card className="p-6 bg-blue-50 border-l-4 border-blue-600">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0 text-blue-600">
            <FiClock className="w-5 h-5 mt-1" />
          </div>
          <div>
            <p className="font-semibold text-blue-900 mb-1">
              {language === 'ko' ? '빠른 응답' : 'Quick Response'}
            </p>
            <p className="text-sm text-blue-800">
              {language === 'ko'
                ? '문의하신 내용은 영업일 기준 24시간 이내에 답변드립니다.'
                : 'We respond to all inquiries within 24 hours on business days.'}
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ContactInfo;
